import React from 'react';
import { Router } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { createBrowserHistory } from 'history';
import MomentUtils from '@date-io/moment';
import { Provider as StoreProvider } from 'react-redux';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { theme } from './theme';
import { configureStore } from './store';
import routes from './routes';
import GoogleAnalytics from './components/GoogleAnalytics';
import ScrollReset from './components/ScrollReset';
import StylesProvider from './components/StylesProvider';
import { InMemoryCache } from '@apollo/client/cache';
import { ApolloClient } from 'apollo-client';
import { ApolloProvider } from '@apollo/react-hooks';
import { HttpLink } from 'apollo-link-http';
import { ApolloLink, from } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { gql } from 'apollo-boost';

import './mixins/chartjs';
import './mixins/moment';
import './mixins/validate';
import './mixins/prismjs';
import './mock';
import './assets/scss/main.scss';
import { ToastProvider } from './components/ToastProvider';
import { ThemeProvider } from '@material-ui/styles';
import { ThemeProvider as NewThemeProvider } from '@mui/material/styles';

const history = createBrowserHistory();
const store = configureStore();

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext({
    headers: {
      Authorization: `Bearer ${localStorage.getItem('auth')}`
    }
  });

  return forward(operation);
});

const errorLink = new onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );

  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const link = new HttpLink({
  uri: `//${import.meta.env.VITE_API_DOMAIN}/graphql`,
  credentials: 'include' //TODO: Possibly change to same-origin in prod
});

const cache = new InMemoryCache({
  possibleTypes: {
    Course: ['online', 'classroom']
  },
  typePolicies: {
    Company: {
      keyFields: ['uuid']
    },
    MachineReport: {
      keyFields: ['uuid']
    }
  }
});

const client = new ApolloClient({
  link: from([errorLink, authMiddleware, link]),
  cache,
  defaultOptions: {
    query: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all'
    }
  },
  typeDefs: gql`
    enum AccessType {
      restricted
      open
    }

    enum CourseType {
      online
      classroom
      scorm
    }
  `
});

function App() {
  const direction = 'ltr';

  return (
    <StoreProvider store={store}>
      <ThemeProvider theme={theme}>
        <NewThemeProvider theme={theme}>
          <StylesProvider direction={direction}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <ToastProvider>
                <ApolloProvider client={client}>
                  <Router history={history}>
                    <ScrollReset />
                    <GoogleAnalytics />
                    {renderRoutes(routes)}
                  </Router>
                </ApolloProvider>
              </ToastProvider>
            </MuiPickersUtilsProvider>
          </StylesProvider>
        </NewThemeProvider>
      </ThemeProvider>
    </StoreProvider>
  );
}

export default App;
